import fileDownload from 'js-file-download'

import axiosAuth from './axiosAuth'

export const downloadChangesReport = (params: URLSearchParams) =>
    axiosAuth
        .get('/faq-changelog/report', {
            responseType: 'blob',
            params,
        })
        .then((response) => {
            fileDownload(response.data, 'changes_report.xlsx')
        })
